<template>
    <div class="badge badge-green inline-flex items-center space-x-2">
        <div class="space-x-1">
            <span v-if="address.street_1">{{ address.street_1 }}</span>
            <span v-if="address.city">{{ address.city }},</span>
            <span v-if="address.state">{{ address.state }}</span>
            <span v-else>{{ address.country }}</span>
        </div>

        <button
            @click.prevent="deleteAddress"
            class="flex items-center hover:text-gray-100 p-1"
        >
            <icon type="x" class="w-4 h-4" />
        </button>
    </div>
</template>

<script>
import Icon from './shared/Icon'
import Form from '@/functions/Form'

export default {
    props: {
        address: {
            type: Object,
            required: true,
        },
        route: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            form: Form({})
        }
    },
    methods: {
        deleteAddress() {
            this.form.delete(this.route, {
                onSuccess: () => window.location.reload()
            })
        }
    },
    components: {
        Icon,
    },
}
</script>
